import React from "react";
import {cx} from "../../lib/ClassSet";

const PreferredCourierServiceItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "preferred-courier-service-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("accountId")}</td>
      <td className="field">{data.get("courierId")}</td>
      <td className="field f-id f-nolink">{data.get("countryCode")}</td>
      <td className="field f-id f-nolink">{data.get("service")}</td>
    </tr>
  )
}

export default PreferredCourierServiceItem;